import * as React from 'react';

import { OrgMembershipsProvider } from '@/contexts/org-memberships-context';
import { TRPCProvider } from '../lib/api/trpc-provider';
import { Toaster } from '@/components/ui/toaster';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <TRPCProvider>
      <OrgMembershipsProvider>
        <Toaster />
        {children}
      </OrgMembershipsProvider>
    </TRPCProvider>
  );
}
